import { cloneElement } from 'react';

import { Box, ButtonProps, forwardRef, rem } from '@bonusly/design-system';

export const ControlButton = forwardRef<ButtonProps, 'button'>(({ children, isActive, ...rest }, ref) => {
	return (
		<Box
			as="button"
			boxSize={8}
			bg="none"
			borderRadius={rem(4)}
			color="secondary.fg"
			lineHeight={1}
			ref={ref}
			transitionDuration="normal"
			transitionProperty="background-color"
			type="button"
			_active={{
				bg: 'secondary.bgAlphaActive',
			}}
			_hover={{
				bg: 'secondary.bgAlphaHover',
			}}
			{...(isActive && {
				bg: 'secondary.bgAlphaActive',
			})}
			{...rest}
		>
			{cloneElement(children as React.ReactElement, { size: 'sm' })}
		</Box>
	);
});
